"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sortActivitiesByPublishedDate = exports.sanitizeActivity = exports.isRootActivity = exports.isReplyActivity = exports.isNewer = exports.isEditActivity = exports.isDeleteActivity = exports.isCreateActivity = exports.getPublishedDate = exports.getParentId = exports.getIsActivityOrphaned = exports.getActivityType = exports.determineActivityType = exports.createRootActivity = exports.createReplyEditActivity = exports.createReplyActivity = exports.createEditActivity = exports.OLDER = exports.NEWER = exports.MID = exports.INITIAL = exports.ACTIVITY_TYPES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var OLDER = 'older';
exports.OLDER = OLDER;
var NEWER = 'newer';
exports.NEWER = NEWER;
var MID = 'mid';
exports.MID = MID;
var INITIAL = 'initial';
exports.INITIAL = INITIAL;
var ACTIVITY_TYPES = {
  REPLY: 'REPLY',
  EDIT: 'EDIT',
  REACTION: 'REACTION',
  REACTION_SELF: 'REACTION_SELF',
  ROOT: 'ROOT',
  CREATE: 'CREATE',
  TOMBSTONE: 'TOMBSTONE',
  DELETE: 'DELETE',
  REPLY_EDIT: 'REPLY_EDIT'
};
exports.ACTIVITY_TYPES = ACTIVITY_TYPES;
var REPLY = 'reply';
var EDIT = 'edit';
var REACTION_SUMMARY = 'reactionSummary';
var REACTION_SELF_SUMMARY = 'reactionSelfSummary';
var CREATE = 'create';
var TOMBSTONE = 'tombstone';
var DELETE = 'delete';
var ADD = 'add';
var getActivityType = function getActivityType(activity) {
  var _activity$parent, _activity$parent2;
  if (((_activity$parent = activity.parent) === null || _activity$parent === void 0 ? void 0 : _activity$parent.type) === REPLY) {
    return ACTIVITY_TYPES.REPLY;
  }
  if (((_activity$parent2 = activity.parent) === null || _activity$parent2 === void 0 ? void 0 : _activity$parent2.type) === EDIT) {
    return ACTIVITY_TYPES.EDIT;
  }
  if (activity.verb === ADD || activity.type === REACTION_SUMMARY) {
    return ACTIVITY_TYPES.REACTION;
  }
  if (activity.type === REACTION_SELF_SUMMARY) {
    return ACTIVITY_TYPES.REACTION_SELF;
  }
  if (activity.verb === CREATE) {
    return ACTIVITY_TYPES.CREATE;
  }
  if (activity.verb === TOMBSTONE) {
    return ACTIVITY_TYPES.TOMBSTONE;
  }
  if (activity.verb === DELETE) {
    return ACTIVITY_TYPES.DELETE;
  }
  return ACTIVITY_TYPES.ROOT;
};
exports.getActivityType = getActivityType;
var getPublishedDate = function getPublishedDate() {
  var activity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Date(activity.published).getTime();
};

/**
 * @param {Object} activity1
 * @param {Object} activity2
 * @returns {boolean} true if first activity is newer than second
 */
exports.getPublishedDate = getPublishedDate;
var isNewer = function isNewer(activity1, activity2) {
  return getPublishedDate(activity1) > getPublishedDate(activity2);
};
exports.isNewer = isNewer;
var sortActivitiesByPublishedDate = function sortActivitiesByPublishedDate(activities) {
  return (0, _sortBy2.default)(activities, function (activity) {
    return getPublishedDate(activity);
  });
};
exports.sortActivitiesByPublishedDate = sortActivitiesByPublishedDate;
var getParentId = function getParentId(activity) {
  var _activity$parent3;
  return activity === null || activity === void 0 ? void 0 : (_activity$parent3 = activity.parent) === null || _activity$parent3 === void 0 ? void 0 : _activity$parent3.id;
};
exports.getParentId = getParentId;
var isRootActivity = function isRootActivity(act) {
  return getActivityType(act) === ACTIVITY_TYPES.ROOT;
};
exports.isRootActivity = isRootActivity;
var isReplyActivity = function isReplyActivity(act) {
  return getActivityType(act) === ACTIVITY_TYPES.REPLY;
};
exports.isReplyActivity = isReplyActivity;
var isEditActivity = function isEditActivity(act) {
  return getActivityType(act) === ACTIVITY_TYPES.EDIT;
};
exports.isEditActivity = isEditActivity;
var isCreateActivity = function isCreateActivity(act) {
  return getActivityType(act) === ACTIVITY_TYPES.CREATE;
};
exports.isCreateActivity = isCreateActivity;
var isDeleteActivity = function isDeleteActivity(act) {
  return getActivityType(act) === ACTIVITY_TYPES.DELETE;
};
exports.isDeleteActivity = isDeleteActivity;
var sanitizeActivity = function sanitizeActivity(activity) {
  var final = _objectSpread({}, activity);
  final.reaction = activity.reaction || {};
  final.reactionSelf = activity.reactionSelf || {};

  // replies will be spread in order beneath parent, no need to include on final objects
  delete final.replies;
  return final;
};
exports.sanitizeActivity = sanitizeActivity;
var getIsActivityOrphaned = function getIsActivityOrphaned(activity, activities) {
  return activity.parent && activity.parent.id && !activities[activity.parent.id];
};
exports.getIsActivityOrphaned = getIsActivityOrphaned;
var getIsReplyEditActivity = function getIsReplyEditActivity(activity, activities) {
  var parentId = activity.parent.id;
  var parentActivity = activities[parentId];
  return parentActivity && isReplyActivity(parentActivity);
};
var determineActivityType = function determineActivityType(activity, activities) {
  var initialType = getActivityType(activity);

  // edits to a reply, while they are replies themselves, appear in every way as edits
  // the only way to dermine their status as an edited reply is to find the original reply
  if (initialType === ACTIVITY_TYPES.EDIT) {
    var isReplyEditActivity = getIsReplyEditActivity(activity, activities);
    return isReplyEditActivity ? ACTIVITY_TYPES.REPLY_EDIT : initialType;
  }
  return initialType;
};
exports.determineActivityType = determineActivityType;
var createRootActivity = function createRootActivity(activity) {
  return activity;
};
exports.createRootActivity = createRootActivity;
var createReplyActivity = function createReplyActivity(activity) {
  var replyAct = _objectSpread(_objectSpread({}, activity), {}, {
    replyParent: activity.parent
  });
  return replyAct;
};
exports.createReplyActivity = createReplyActivity;
var createEditActivity = function createEditActivity(editActivity, activities) {
  var editActParentObj = editActivity.parent;
  var parentId = editActParentObj.id;
  var parentAct = activities[parentId];
  var joinedEditAct = _objectSpread(_objectSpread({}, parentAct), {}, {
    id: editActivity.id,
    parent: editActParentObj,
    editParent: editActParentObj,
    object: editActivity.object,
    published: editActivity.published
  });
  return joinedEditAct;
};

// takes an edit activity whose parent is a reply activity
exports.createEditActivity = createEditActivity;
var createReplyEditActivity = function createReplyEditActivity(editActivity, activities) {
  var editActParentObj = editActivity.parent;
  var parentId = editActParentObj.id;
  var parentReplyAct = activities[parentId];
  var joinedReplyEditActivity = _objectSpread(_objectSpread({}, parentReplyAct), {}, {
    id: editActivity.id,
    parent: editActParentObj,
    editParent: editActParentObj,
    replyParent: parentReplyAct.parent,
    object: editActivity.object,
    published: editActivity.published
  });
  return joinedReplyEditActivity;
};
exports.createReplyEditActivity = createReplyEditActivity;
//# sourceMappingURL=activities.js.map
